import { render, staticRenderFns } from "./StepFocus.vue?vue&type=template&id=45001c4a&scoped=true&"
import script from "./StepFocus.vue?vue&type=script&lang=js&"
export * from "./StepFocus.vue?vue&type=script&lang=js&"
import style0 from "./StepFocus.vue?vue&type=style&index=0&id=45001c4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45001c4a",
  null
  
)

export default component.exports